import { useState, useEffect } from "react";
import glv from "../../utils/getLocalizedValue";

export function Popup({ name, children }) {
  const [isOpen, setIsOpen] = useState(false);

  const localStorageKey = `${name}_date`;

  useEffect(() => {
    const today = new Date().toISOString().split("T")[0];
    const hideDate = localStorage.getItem(localStorageKey);

    if (hideDate !== today) {
      setIsOpen(true);
    }
  }, []);

  const handleClose = () => {
    setIsOpen(false);
  };

  const handleHideToday = () => {
    const today = new Date().toISOString().split("T")[0];
    localStorage.setItem(localStorageKey, today);
    setIsOpen(false);
  };

  if (!isOpen) return null;

  return (
    <>
      <div className="fixed z-[2147483647] inset-0 flex items-center justify-center bg-black bg-opacity-40">
        <div className="p-0 bg-white 3xl:max-w-[600px] xl:max-w-[450px] md:max-w-[400px] md:m-0 mx-5 w-[100%] max-w-[400px]">
          <div>{children}</div>
          <div className="justify-end gap-2 flex text-2xl md:text-sm text-brand-steel-grey font-medium">
            <button className="px-4 py-2" onClick={handleClose}>
              {glv("Close","닫기")}
            </button>
            <button className="px-4 py-2" onClick={handleHideToday}>
              {glv("Hide for today","오늘 하루 보지 않기")}
            </button>
          </div>
        </div>
      </div>
    </>
  );
}